import * as dayLib from 'dayjs';
import day from 'dayjs';

import duration from 'dayjs/plugin/duration';
dayLib.extend(duration);

import relativeTime from 'dayjs/plugin/relativeTime';
dayLib.extend(relativeTime);

import calendar from 'dayjs/plugin/calendar';
dayLib.extend(calendar);

export { dayLib, day };

export function formatDistanceToNow(date: Date, withoutSuffix = true) {
    return day(date).fromNow(withoutSuffix);
}

export function formatDateTime(
    date: Date,
    format = new Intl.DateTimeFormat(navigator?.language ?? 'en', {
        dateStyle: 'short',
        timeStyle: 'short',
    })
) {
    return format.format(date);
}
